var render = function render(){var _vm=this,_c=_vm._self._c;return (
    _vm.object.recordtype === 'kititem' &&
      _vm.object.pricegroup !== '5e0dbaba9e33df43f0b3a4d0' &&
      _vm.object.manufacturergroup !== _vm.MANUFACTURER.REDARC
  )?_c('div',{staticClass:"double-table"},_vm._l((_vm.comboComponents),function(item){return _c('table-details',{key:item.id,attrs:{"name":item.name,"technicaldetails":item.technicaldetails,"weight":item.weight,"axle":_vm.axle}})}),1):_c('div',{staticClass:"double-table"},[_c('table-details',{attrs:{"technicaldetails":_vm.object.technicaldetails,"weight":_vm.object.weight}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }